import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getHomeRoute } from "@/lib/roleRouter";

// NAV-SWEEP-1b (N7) — this card used to be effectively unreachable (every denial redirected before
// it could render), so nobody noticed it printed the RAW ROLE CONSTANT: "You are signed in as
// school_admin." Now that a denial actually lands here, that is a dev label in front of the reader.
const ROLE_LABEL = {
  teacher: "a teacher",
  school_admin: "a school administrator",
  training_admin: "a training administrator",
  super_admin: "a super administrator",
};

export function RoleMismatchPage({ user, requiredRole, currentRole }) {
  const location = useLocation();

  const homeRoute = getHomeRoute(user);
  const attemptedPath = location?.pathname || "";

  const rawRole =
    currentRole ||
    user?.tenant_role ||
    user?.tenantRole ||
    user?.role ||
    "";

  const resolvedCurrentRole = ROLE_LABEL[rawRole] || "your current role";

  return (
    <div className="min-h-screen bg-ivory px-4 py-10">
      {/* UX-5: a worst-moment surface, dressed as the landing being gracious — ivory field, warm
          paper card, serif headline, one gold rule, ink body. */}
      <div className="mx-auto max-w-2xl rounded-2xl border border-slate-200 bg-paper p-8 shadow-sm">
        <p className="text-sm font-semibold uppercase tracking-wide text-ink-2">
          Cognivio Access
        </p>

        <h1 className="mt-2 font-display text-3xl font-bold text-ink">
          This page is not available for your role
        </h1>
        <span className="mt-3 block h-1 w-12 rounded-full bg-gold" aria-hidden="true" />

        <p className="mt-4 text-slate-600">
          You are signed in as{" "}
          <span className="font-semibold text-slate-900">
            {resolvedCurrentRole}
          </span>
          {requiredRole ? (
            <>
              , but this page requires{" "}
              <span className="font-semibold text-slate-900">
                {requiredRole}
              </span>
              .
            </>
          ) : (
            "."
          )}
        </p>

        {attemptedPath && (
          <p className="mt-3 rounded-xl bg-slate-100 px-4 py-3 text-sm text-slate-700">
            Requested page: <span className="font-mono">{attemptedPath}</span>
          </p>
        )}

        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <Link
            to={homeRoute}
            className="rounded-xl bg-ink px-5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-ink-2"
          >
            Go to my dashboard
          </Link>

          <Link
            to="/login"
            className="rounded-xl border border-slate-300 px-5 py-2.5 text-center text-sm font-semibold text-slate-700"
          >
            Switch account
          </Link>
        </div>

        <p className="mt-6 text-sm text-slate-500">
          If you believe you should have access, contact your school or workspace administrator.
        </p>
      </div>
    </div>
  );
}

export default RoleMismatchPage;